<div
    ngbAccordion
    class="d-flex flex-column gap-1 px-2 py-3 w-100 h-100"
    #accordion="ngbAccordion"
    [closeOthers]="true">

    @for (navGroup of navState.navGroups; track navGroup.id; let isLast = $last) {
        <div
            [ngbAccordionItem]="navGroup.id"
            [disabled]="!navGroup.children?.length"
            [collapsed]="true"
            [ngClass]="{'mt-auto': isLast}">

            @if (navGroup.link !== undefined) {
                @if (navGroup.isExternalLink) {
                    <!-- External nav group link -->
                    <a
                        ngbAccordionHeader
                        [href]="navGroup.link[0]"
                        target= "_blank"
                        rel="noopener"
                        referrerpolicy="no-referrer"
                        [ngClass]="getNavGroupClasses(navGroup.id)"
                        class="accordion-button custom-header justify-content-between">
                        <ng-container [ngTemplateOutlet]="accordionGroup"></ng-container>
                    </a>
                } @else {
                    <!-- Internal nav group link -->
                    <a
                        ngbAccordionHeader
                        [routerLink]="navGroup.link"
                        [ngClass]="getNavGroupClasses(navGroup.id)"
                        class="accordion-button custom-header justify-content-between"
                        (click)="onNavGroupClick($event, navGroup.id)">
                        <ng-container [ngTemplateOutlet]="accordionGroup"></ng-container>
                    </a>
                }
            } @else {
                <button
                    type="button"
                    [ngClass]="getNavGroupClasses(navGroup.id)"
                    class="accordion-button custom-header justify-content-between"
                    (click)="navGroup.onClick()">
                    <ng-container [ngTemplateOutlet]="accordionGroup"></ng-container>
                </button>
            }

            <!-- Contents of the accordion header -->
            <ng-template #accordionGroup>
                <p class="m-0 px-1">
                    <fa-icon
                        [icon]="navGroup.icon"
                        [ngClass]="{'text-secondary': !isNavGroupSelected(navGroup.id), 'text-primary-500': isNavGroupSelected(navGroup.id) }"
                        [fixedWidth]="true"
                        class="me-2"/>
                    <span>{{navGroup.label}}</span>
                </p>
                @if (navGroup.isExternalLink) {
                    <fa-icon
                        class="text-secondary px-2"
                        [icon]="faArrowUpRightFromSquare"
                        [fixedWidth]="true"/>
                }
                @if (navGroup.children?.length) {
                    <button
                        ngbAccordionToggle
                        type="button"
                        class="btn btn-ghost d-flex align-items-center justify-content-center"
                        (click)="onToggleNavGroup($event)">
                        <fa-icon
                            class="no-margin"
                            [icon]="faChevronRight"
                            [fixedWidth]="true"
                            [transform]="!isAccordionItemOpen(navGroup.id) ? 'rotate-0' : 'rotate-90'"/>
                    </button>
                }
            </ng-template>

            <!-- Contents of accordion -->
            <div ngbAccordionCollapse>
                @if (navGroup.children?.length) {
                    <div ngbAccordionBody class="p-0 pt-1">
                        <ng-template>
                            <div ngbNav #nav="ngbNav" class="nav-pills flex-column w-100" orientation="vertical">
                                @for (subNav of navGroup.children; track subNav.id) {
                                    <ng-container [ngbNavItem]="subNav.id">
                                        <div class="nav-pills-container d-flex" [ngClass]="getSubNavClasses(subNav.id)">
                                            @if (subNav.link !== undefined) {

                                                @let upgradeTier = subNav.showUpgradeBadge ? subNav.showUpgradeBadge() : false;

                                                @if (subNav.isExternalLink) {
                                                    <!-- External sub nav link -->
                                                    <a
                                                        [href]="subNav.link[0]"
                                                        target="_blank"
                                                        rel="noopener"
                                                        referrerpolicy="no-referrer"
                                                        class="text-start d-flex justify-content-between align-items-center flex-grow-1 p-1">
                                                        <span>{{subNav.label}}</span>
                                                        <fa-icon
                                                            class="text-secondary px-2"
                                                            [icon]="faArrowUpRightFromSquare"/>
                                                    </a>
                                                } @else if (upgradeTier) {
                                                    <button
                                                        #upgradeButton
                                                        type="button"
                                                        class="btn-nav text-start d-flex justify-content-between align-items-center flex-grow-1 p-1 border-0"
                                                        (click)="upgradePopover.invokePopover()"
                                                        [class.active]="upgradePopover.isPopoverOpen">
                                                        <span>{{subNav.label}}</span>
                                                        <fdx-surface-tier-icon-button
                                                            [clickable]="false"
                                                            [tier]="upgradeTier"
                                                            size="sm"/>
                                                    </button>
                                                    <fdx-surface-upgrade-popover
                                                        #upgradePopover
                                                        [target]="upgradeButton"
                                                        [feature]="subNav.upgradeFeature"
                                                        [tier]="upgradeTier"
                                                        placement="end"/>
                                                } @else {
                                                    <!-- Internal sub nav link -->
                                                    <a
                                                        [routerLink]="subNav.link"
                                                        class="text-start d-flex justify-content-between align-items-center flex-grow-1 p-1">
                                                        <span>{{subNav.label}}</span>
                                                    </a>
                                                }
                                            } @else {
                                                <button
                                                    type="button"
                                                    class="btn-nav text-start d-flex justify-content-between align-items-center flex-grow-1 p-1 border-0"
                                                    (click)="subNav.onClick()">
                                                    <span>{{subNav.label}}</span>
                                                </button>
                                            }
                                        </div>
                                    </ng-container>
                                }
                            </div>
                        </ng-template>
                    </div>
                }
            </div>
        </div>
    }
</div>
